import windowStorage from './window-storage'

const SONGS_KEY = 'tabify-recent-songs'
const SETS_KEY = 'tabify-recent-setlists'

const MAX_SONGS = 5
const MAX_SETLISTS = 3

const pushToFrontWithLimit = (array, element, maxLength) => {
  array.unshift(element) // Add the element to the beginning
  if (array.length > maxLength) {
    array.pop() // Remove the last element if the array exceeds the maximum length
  }
  return array
}

export const getRecentSongs = () => {
  try {
    const songs = JSON.parse(windowStorage.getItem(SONGS_KEY))
    if (songs == null) {
      return []
    }
    return songs
  } catch (err) {
    return []
  }
}

export const getRecentSetlists = () => {
  try {
    const sets = JSON.parse(windowStorage.getItem(SETS_KEY))
    if (sets == null) {
      return []
    }
    return sets
  } catch (err) {
    return []
  }
}

export const addRecentSong = (id, display) => {
  try {
    const currentSongs = getRecentSongs()
    if (currentSongs.find(s => s.id === id)) {
      // if already in recents, dont add it
      return
    }
    const updated = pushToFrontWithLimit(currentSongs, {
      id, display
    }, MAX_SONGS)
    windowStorage.setItem(SONGS_KEY, JSON.stringify(updated))
  } catch (err) {
    console.log(err)
  }
}

export const addRecentSetlist = (id, display) => {
  try {
    const currentSets = getRecentSetlists()
    if (currentSets.find(s => s.id === id)) {
      // if already in recents, dont add it
      return
    }
    const updated = pushToFrontWithLimit(currentSets, {
      id, display
    }, MAX_SETLISTS)
    windowStorage.setItem(SETS_KEY, JSON.stringify(updated))
  } catch (err) {
    console.log(err)
  }
}
